const PaymentResponseHandler = () => {
    return(
        <>
        hii
        </>
    )
}

export default PaymentResponseHandler